import React from "react";
import "../../styles/Tabella.css"


function TabellaRunnering() {
    return(
        <div className="table-container" style={{margin: "0 1em 0 1em"}}>
            <table className="table m-auto text-center" style={{maxWidth: "70em"}}>
                <colgroup>
                    <col style={{ width: "15%"}} />
                    <col style={{ width: "15%"}} />
                    <col style={{ width: "15%"}} />
                    <col style={{ width: "15%"}} />
                    <col style={{ width: "15%"}} />
                    <col style={{ width: "15%"}} />
                </colgroup>
                <thead>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mar</th>
                    <th className="" scope="col">Mer</th>
                    <th className="" scope="col">Gio</th>
                    <th className="" scope="col">Ven</th>
                    <th className="" scope="col">Sab</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell">10:15 <br className="d-sm-none"/> - <br className="d-sm-none"/>11:15</td>
                </tr>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell">11:15 <br className="d-sm-none"/> - <br className="d-sm-none"/>12:15</td>
                </tr>
                <tr>
                    <td className="data-cell">13:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 14:15</td>
                    <td className="data-cell">13:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 14:15</td>
                    <td className="data-cell">13:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 14:15</td>
                    <td className="data-cell">13:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 14:15</td>
                    <td className="data-cell">13:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 14:15</td>
                    <td className="data-cell"></td>
                </tr>
                <tr>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19:30</td>
                    <td className="data-cell"></td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19:30</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19:30</td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                </tr>
                <tr>
                    <td className="data-cell">19:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:30</td>
                    <td className="data-cell"></td>
                    <td className="data-cell">19:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:30</td>
                    <td className="data-cell">19:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:30</td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaRunnering